module.exports = __webpack_public_path__ + "img/CHEVRON_LEFT.a109dfa4.svg";